import { Component, inject, OnInit, signal, Signal } from '@angular/core';
import { crmKillEvent } from '@touch4it/ng-swp/core';
import { CrmLayoutV2FragmentDirective } from '@touch4it/ng-swp/layout-v2';
import { CrmModalService } from '@touch4it/ng-swp/modal';
import { CrmTranslateService } from '@touch4it/ng-swp/translate';
import { NzAvatarComponent } from 'ng-zorro-antd/avatar';
import { NzIconDirective } from 'ng-zorro-antd/icon';

import { AuthService } from '~/api/auth/auth.service';

import { LogoutProvider } from './logout.provider';

@Component({
  selector: 'app-logout',
  host: {
    class: 'layout-logout',
    '[class.layout-logout--collapsed]': 'collapsed()',
    '(click)': 'handleClick($event)',
  },
  template: `
    @if (!collapsed()) {
      <div class="layout-logout__user">
        <nz-avatar nzIcon="user"></nz-avatar>
        <span>{{ user.name() }}</span>
      </div>
    }

    <div class="layout-logout__sign-out">
      <span nz-icon nzType="poweroff" nzTheme="outline"></span>
    </div>
  `,
  imports: [NzIconDirective, NzAvatarComponent],
  providers: [LogoutProvider],
})
export class LogoutComponent extends CrmLayoutV2FragmentDirective<LogoutProvider> implements OnInit {
  protected collapsed!: Signal<boolean>;

  protected user = inject(AuthService);
  private modal = inject(CrmModalService);
  private ts = inject(CrmTranslateService);

  ngOnInit() {
    this.initProvider(LogoutProvider);
  }

  protected handleClick(event: MouseEvent) {
    crmKillEvent(event);

    this.modal.confirm({
      nzTitle: this.ts.get('logout.modal.title'),
      nzOkText: this.ts.get('logout.modal.submit'),
      nzOkDanger: true,
      nzOnOk: () => this.user.logout().subscribe(),
    });
  }

  protected override initComponent() {
    this.collapsed = this.siderControl?.collapsed ?? signal(false).asReadonly();
  }
}
